import { render, staticRenderFns } from "./vActivityList.vue?vue&type=template&id=6c84d7da&"
import script from "./vActivityList.vue?vue&type=script&lang=js&"
export * from "./vActivityList.vue?vue&type=script&lang=js&"
import style0 from "./vActivityList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports